export const en = {
  SERVER_ERROR: "INTERNAL SERVER ERROR"
};

export const ar = {
  SERVER_ERROR: "خطأ في الخادم"
};
